//Estilos de Layout

export const contentStyle: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: 'calc(100vh - 90px)',
  padding: '40px',
  backgroundColor: '#ffffff',
}

export const footerStyle: React.CSSProperties = {
  textAlign: 'center',
  color: '#fff',
}

export const layoutStyle: React.CSSProperties = {
  minHeight: '100vh',
}

export const layoutStyleSteps: React.CSSProperties = {
  minHeight: '100vh',
  marginTop: '16px',
}

//Estilos Register-Login Section
export const textSubtitle: React.CSSProperties = {
  fontSize: '14px',
  fontStyle: 'normal',
  fontWeight: 500,
  lineHeight: '22px',
  fontFamily: 'Montserrat',
  textAlign: 'center',
  color: '#00000073',
  display: 'block',
}
export const textSmall: React.CSSProperties = {
  fontFamily: 'Montserrat',
  fontSize: '12px',
  fontStyle: 'normal',
  fontWeight: 500,
  lineHeight: '20px',
  color: '#00000073',
}

export const submitFormButton: React.CSSProperties = {
  width: '100%',
  backgroundColor: '#0F687C',
  borderColor: '#0F687C',
  color: '#fff',
  borderRadius: '8px',
  height: '40px',
}
